<template>
  <div class="testOne">
    <!-- <canvas width="500" height="500" ref="singleChoose"></canvas> -->
    <div class="button">
      <div class="button-item" v-for="(item,index) in selectArr" :key="index" @click.stop="confirmAns(item,index)">
        {{item}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'testOne',
  props: {
    question: {
      type: Object,
      default: null,
    },
    reload: {
      type: Number,
    },
    genre: {
      type: String,
      default: '',
    },
  },
  computed: {},
  watch: {
    // reload() {
    //   this.initSelectorOfAns();
    // },
    question() {
      this.initSelectorOfAns();
    },
  },
  data() {
    return {
      selectArr: [], // 选择选项
    };
  },
  created() {},
  mounted() {
    if (this.question.selector) {
      this.selectArr = this.question.selector.split('||||');
    }
    console.log(this.question);
    console.log(this.selectArr);
  },
  methods: {
    // 获取答案正确与否
    confirmAns(item, index) {
      const answer = {
        desc: '', // 答案结果
        data: item, // 学生的答案
      };
      answer.desc = item;
      // if (index === 0) { answer.desc = 'A'; }
      // if (index === 1) { answer.desc = 'B'; }
      // if (index === 2) { answer.desc = 'C'; }
      // if (index === 3) { answer.desc = 'D'; }
      // if (index === 4) { answer.desc = 'E'; }
      if (answer.desc === this.question.answer) {
        answer.desc = '正确';
        this.$emit('getResult_test', answer);
      } else {
        answer.desc = '错误';
        this.$emit('getResult_test', answer);
      }
    },
    // 初始化答案选项
    initSelectorOfAns() {
      let str = [];
      if (this.question.selector) {
        str = this.question.selector.split('||||');
      }
      this.selectArr = str;
    },
  },
};
</script>
<style scoped lang="scss">
  .testOne{
    width: 100%;
    height:100%;
    margin:auto;
    text-align:center;
    .answers{
      width:halvePx(670);
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto;
      margin-top:halvePx(86);
      img{
        display:inline-block;
        width:halvePx(44);
        height:halvePx(60);
      }
      .answers-choose{
        height:auto;
        .choose-item{
          width:halvePx(540);
          height:halvePx(100);
          background:rgba(250,229,179,1);
          border:halvePx(2) solid rgba(196, 178, 135, 1);
          border-radius:halvePx(50);
          margin:auto;
          font-size:halvePx(30);
          font-family:PingFang-SC-Regular;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:halvePx(100);
          text-align: center;
          margin:halvePx(20);
        }
      }
    }
    .button{
      width:80%;
      margin:auto;
      .button-item{
        width:100%;
        height:halvePx(100);
        line-height: halvePx(100);
        text-align: center;
        background:rgba(250,229,179,1);
        border:halvePx(2) solid rgba(196, 178, 135, 1);
        border-radius:halvePx(50);
        margin:halvePx(20);
        font-size:halvePx(30);
        font-family:PingFang-SC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
      }
    }
  }
</style>
